import React from 'react';

/**
 * Catches lazy-loaded chunk failures (e.g. stale PWA cache)
 * and auto-reloads the page once. Prevents blank screens.
 */
class ChunkErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Detect chunk load errors
    if (
      error?.name === 'ChunkLoadError' ||
      error?.message?.includes('Loading chunk') ||
      error?.message?.includes('dynamically imported module') ||
      error?.message?.includes('Failed to fetch')
    ) {
      return { hasError: true };
    }
    return { hasError: true };
  }

  componentDidCatch(error) {
    // Only auto-reload once per session to avoid infinite loops
    const key = 'rektra_chunk_reload';
    const last = sessionStorage.getItem(key);
    const now = Date.now();
    if (!last || now - Number(last) > 10000) {
      sessionStorage.setItem(key, String(now));
      window.location.reload();
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex flex-col items-center justify-center min-h-[60vh] gap-4 p-6 text-center">
          <p className="text-foreground-muted text-sm">Síða hleðst ekki. Reyndu aftur.</p>
          <button
            onClick={() => window.location.reload()}
            className="btn btn-primary btn-sm"
            data-testid="chunk-error-reload"
          >
            Endurhlaða
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ChunkErrorBoundary;
